<template>
    <div>
        <div v-for="(lector, index) in templateArgs.lectors" :key="index">
            <p>{{lector.fullName}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'annualCatalogLectorsTemplate',
        data() {
            return {
                templateArgs: {}
            };
        },
    }
</script>

<style scoped>

</style>
